import * as constants from '../constants/v2_training_modules'
import Api from '../services/api.js'

export function getV2TrainingModulesRequest(){
  return {
    type: constants.GET_V2_TRAINING_MODULES_REQUEST,
  }
}

export function getV2TrainingModulesSuccess(body){
  return {
    type: constants.GET_V2_TRAINING_MODULES_SUCCESS,
    body: body
  }
}

export function getV2TrainingModulesFailure(exception){
  return {
    type: constants.GET_V2_TRAINING_MODULES_FAILURE,
    exception: exception
  }
}

export function getV2TrainingModules(params) {
  return dispatch => {
    dispatch(getV2TrainingModulesRequest())
    const api = new Api();
    return api.makeRequest({
      method: "get",
      url: "/api/v1/v2_training_modules",
      params: params
    })
    .then(response => {
      dispatch(getV2TrainingModulesSuccess(response.data))
    })
    .catch(err => dispatch(getV2TrainingModulesFailure(err)))
  }
}

export function createV2TrainingModuleRequest(){
  return {
    type: constants.CREATE_V2_TRAINING_MODULE_REQUEST,
  }
}

export function createV2TrainingModuleSuccess(body){
  return {
    type: constants.CREATE_V2_TRAINING_MODULE_SUCCESS,
    body: body
  }
}

export function createV2TrainingModuleFailure(exception){
  return {
    type: constants.CREATE_V2_TRAINING_MODULE_FAILURE,
    exception: exception
  }
}

export function createV2TrainingModule(params) {
  return dispatch => {
    dispatch(createV2TrainingModuleRequest())
    const api = new Api();
    return api.post("/api/v1/v2_training_modules", params)
    .then(response => {
      dispatch(createV2TrainingModuleSuccess(response.data))
    })
    .catch(err => dispatch(createV2TrainingModuleFailure(err)));
  }
}

export function updateV2TrainingModuleRequest(){
  return {
    type: constants.UPDATE_V2_TRAINING_MODULE_REQUEST,
  }
}

export function updateV2TrainingModuleSuccess(body){
  return {
    type: constants.UPDATE_V2_TRAINING_MODULE_SUCCESS,
    body: body
  }
}

export function updateV2TrainingModuleFailure(exception){
  return {
    type: constants.UPDATE_V2_TRAINING_MODULE_FAILURE,
    exception: exception
  }
}

export function updateV2TrainingModule(params) {
  return dispatch => {
    dispatch(updateV2TrainingModuleRequest())
    const api = new Api();
    return api.put("/api/v1/v2_training_modules/"+params.id, params)
    .then(response => {
      dispatch(updateV2TrainingModuleSuccess(response.data))
    })
    .catch(err => dispatch(updateV2TrainingModuleFailure(err)));
  }
}

export function archiveV2TrainingModuleRequest(){
  return {
    type: constants.ARCHIVE_V2_TRAINING_MODULE_REQUEST,
  }
}

export function archiveV2TrainingModuleSuccess(body){
  return {
    type: constants.ARCHIVE_V2_TRAINING_MODULE_SUCCESS,
    body: body
  }
}

export function archiveV2TrainingModuleFailure(exception){
  return {
    type: constants.ARCHIVE_V2_TRAINING_MODULE_FAILURE,
    exception: exception
  }
}

export function archiveV2TrainingModule(v2_training_modules_id) {
  return dispatch => {
    dispatch(archiveV2TrainingModuleRequest())
    const api = new Api();
    return api.put(`/api/v1/v2_training_modules/${v2_training_modules_id}/archive`, {})
    .then(response => {
      dispatch(archiveV2TrainingModuleSuccess(response.data))
    })
    .catch(err => dispatch(archiveV2TrainingModuleFailure(err)));
  }
}

export function unarchiveV2TrainingModuleRequest(){
  return {
    type: constants.UNARCHIVE_V2_TRAINING_MODULE_REQUEST,
  }
}

export function unarchiveV2TrainingModuleSuccess(body){
  return {
    type: constants.UNARCHIVE_V2_TRAINING_MODULE_SUCCESS,
    body: body
  }
}

export function unarchiveV2TrainingModuleFailure(exception){
  return {
    type: constants.UNARCHIVE_V2_TRAINING_MODULE_FAILURE,
    exception: exception
  }
}

export function unarchiveV2TrainingModule(v2_training_modules_id) {
  return dispatch => {
    dispatch(unarchiveV2TrainingModuleRequest())
    const api = new Api();
    return api.put(`/api/v1/v2_training_modules/${v2_training_modules_id}/unarchive`, {})
    .then(response => {
      dispatch(unarchiveV2TrainingModuleSuccess(response.data))
    })
    .catch(err => dispatch(unarchiveV2TrainingModuleFailure(err)));
  }
}

export function renameTag(options) {
  const api = new Api();
  return api.put("/api/v1/tag", options)
}



// WEBPACK FOOTER //
// ./src/actions/v2_training_modules.js